export default "__VITE_ASSET__CWFS$fdb__"